import axios from 'axios'
import gaEvent from 'utilities/tracking'
import { isLoading } from 'containers/Checkout/actions'
import { API_MODEM_URL } from 'containers/Checkout/constants'
import { DEFAULT_RESPONSE_ERROR } from './constants'

export const MODEM_REQUIRED = 'MODEM_REQUIRED'
export const MODEM_ADDRESS_SAME_AS_INSTALL = 'MODEM_ADDRESS_SAME_AS_INSTALL'
export const MODEM_ADDRESS_MANUAL = 'MODEM_ADDRESS_MANUAL'
export const MODEM_SET_FIELDS = 'MODEM_SET_FIELDS'
export const MODEM_SET_ERRORS = 'MODEM_SET_ERRORS'
export const MODEM_CLEAR_ERROR = 'MODEM_CLEAR_ERROR'
export const MODEM_RESPONSE_MESSAGE = 'MODEM_RESPONSE_MESSAGE'
export const MODEM_DELIVERY_SUCCESS = 'MODEM_DELIVERY_SUCCESS'

export function setDeliverySameAsInstall(yesOrNo) {
  return {
    type: MODEM_ADDRESS_SAME_AS_INSTALL,
    payload: yesOrNo,
  }
}

export function setManualAddress(yesOrNo) {
  return {
    type: MODEM_ADDRESS_MANUAL,
    payload: yesOrNo,
  }
}

export function setModemRequired(yesOrNo) {
  return {
    type: MODEM_REQUIRED,
    payload: yesOrNo,
  }
}

export function setFieldValues(fields) {
  return {
    type: MODEM_SET_FIELDS,
    payload: fields,
  }
}

export function setFieldErrors(errors) {
  Object.keys(errors).forEach((field) => {
    gaEvent('Invalid', {
      event_category: 'Modem',
      event_label: field,
      field_name: field,
      error_message: errors[field],
      non_interaction: true,
    })
  })
  return {
    type: MODEM_SET_ERRORS,
    payload: errors,
  }
}

export function clearFieldError(fieldName) {
  return {
    type: MODEM_CLEAR_ERROR,
    payload: fieldName,
  }
}

export function setResponseMessage(status) {
  return {
    type: MODEM_RESPONSE_MESSAGE,
    payload: status,
  }
}

export function modemDeliverySuccess(nextStage, address) {
  return {
    type: MODEM_DELIVERY_SUCCESS,
    payload: {
      next: nextStage,
      address,
    },
  }
}

export function submitData() {
  return async (dispatch, getState) => {
    dispatch(isLoading(true))

    try {
      const {
        modemFields,
        modemSameAsInstallAddress,
        modemRequired,
        modemManualAddress,
      } = getState().checkoutReducer

      const postData = {
        ...modemFields,
        requires_modem: modemRequired,
        same_as_install_address: modemSameAsInstallAddress,
        is_manual_address: modemManualAddress,
      }

      const response = await axios.post(API_MODEM_URL, postData)
      dispatch(isLoading(false))

      if (response.data.success) {
        gaEvent('Success', {
          event_category: 'Modem',
          event_label: modemSameAsInstallAddress ? 'same address' : 'other address',
        })
        dispatch(modemDeliverySuccess(response.data.next, response.data.address))
      } else {
        dispatch(setResponseMessage(DEFAULT_RESPONSE_ERROR))
        gaEvent('Failed', {
          event_category: 'Modem',
          event_label: 'Rejected',
        })
      }
    } catch (error) {
      dispatch(isLoading(false))
      dispatch(setResponseMessage(DEFAULT_RESPONSE_ERROR))
      if (!error.response || !error.response.data.errors) {
        // network error
        gaEvent('Failed', {
          event_category: 'Modem',
          event_label: (error.response && error.response.statusText) || 'Network Error',
        })
      } else {
        // response data
        const response = error.response.data
        dispatch(setFieldErrors(response.errors))
      }
    }
  }
}



// WEBPACK FOOTER //
// ./containers/stages/ModemStage/actions.js